export default "https://sdk.cotreat.ai/check-a64ac6fa.svg";